import { EProjectDiscussionFileType } from './projectDiscussionFile.constants';
import { IProjectDiscussionFileDiscussionIdsProps } from './projectDiscussionFile.models';

export const convertDiscussionIdToIdsProps = (id: number | undefined, type: EProjectDiscussionFileType) => {
  switch (type) {
    case EProjectDiscussionFileType.DESIGN_BRIEF:
      return { projectDesignBriefDiscussionId: id } as IProjectDiscussionFileDiscussionIdsProps;
    case EProjectDiscussionFileType.DESIGN_MODIFICATION_DESIGNER:
      return { projectDesignModificationDiscussionId: id } as IProjectDiscussionFileDiscussionIdsProps;
    case EProjectDiscussionFileType.DESIGN_MODIFICATION_ICE:
      return { projectDesignModificationIceDiscussionId: id } as IProjectDiscussionFileDiscussionIdsProps;
    case EProjectDiscussionFileType.LOADING_REMOVAL_CERT:
      return { projectLoadingRemovalCertDiscussionId: id } as IProjectDiscussionFileDiscussionIdsProps;
    case EProjectDiscussionFileType.TRANSMITTAL:
      return { projectTransmittalDiscussionId: id } as IProjectDiscussionFileDiscussionIdsProps;
    default:
      return {} as IProjectDiscussionFileDiscussionIdsProps;
  }
};
